var map = {
	"./animal.svg": 516,
	"./arrow.svg": 517,
	"./bicycle.svg": 518,
	"./boat.svg": 519,
	"./bus.svg": 520,
	"./car.svg": 521,
	"./crane.svg": 522,
	"./default.svg": 523,
	"./helicopter.svg": 524,
	"./motorcycle.svg": 525,
	"./offroad.svg": 526,
	"./person.svg": 364,
	"./pickup.svg": 527,
	"./plane.svg": 528,
	"./ship.svg": 529,
	"./tractor.svg": 365,
	"./train.svg": 530,
	"./tram.svg": 531,
	"./trolleybus.svg": 532,
	"./truck.svg": 533,
	"./van.svg": 534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1303;